import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate(event) {
    const url = event.target.selectedOptions[0]?.dataset.url

    if (url) window.location.href = url
  }
}
